import { Image, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import Profile from "./Profile";
import NotificationIcon from "src/icons/NotificationIcon";
import ChatMessageIcon from "src/icons/ChatMessageIcon";
import { setGoogleAnalyticsEvent } from "src/common";
import { SSOLinkI } from "src/types/SSOLink";
import { useTranslate } from "@tolgee/react";

/**
 * Renders company specific logo, global search and current user profile options
 */

interface HeaderI {
  agentChatLink?: SSOLinkI;
  ctmLogo: string;
  handleChatOpen: () => void;
  onToggleNav: () => void;
  headerState: {
    isCondensed: boolean;
    isSticky: boolean;
  };
  isImpersonating: string;
  initializeImpersonation: (params: {
    email: string;
    id: string;
    token: string;
  }) => void;
  initializeSwitchAccount: (account: {
    companyName: string;
    companyID: string;
  }) => void;
  clearSwitchAccount: () => void;
  clearImpersonation: () => void;
}

const Header = ({
  agentChatLink,
  ctmLogo,
  handleChatOpen,
  onToggleNav,
  headerState,
  isImpersonating,
  initializeImpersonation,
  clearImpersonation,
  initializeSwitchAccount,
  clearSwitchAccount,
}: HeaderI) => {
  const { t } = useTranslate();
  const { isCondensed, isSticky } = headerState;

  return (
    <header
      className={`header main-header${isCondensed ? " condensed" : ""}${
        isSticky ? " sticky" : ""
      }${isImpersonating ? " impersonation" : ""}`}
    >
      <div className="toggle-logo">
        <button
          className="unstyled-button"
          onClick={onToggleNav}
          aria-label={t({
            key: "header.toggleSideMenu",
            defaultValue: "Toggle Side Menu",
          })}
        >
          <Icon className="hamburger" name="bars" aria-hidden="true" />
        </button>
      </div>
      <div className="ctm-logo" role="heading" aria-level={1}>
        <Image
          src={ctmLogo}
          alt={t({
            key: "header.ctmLogoAlt",
            defaultValue: "CTM Logo",
          })}
          aria-label={t({
            key: "header.smartPortalLabel",
            defaultValue: "Smart Portal",
          })}
        />
      </div>
      <div />
      <div className="right-side-header">
        {agentChatLink && (
          <button
            className="unstyled-button"
            aria-label={t({
              key: "header.agentChatToggle",
              defaultValue: "Agent Chat Toggle",
            })}
            onClick={handleChatOpen}
          >
            <ChatMessageIcon />
          </button>
        )}
        <button
          className="unstyled-button beamerTrigger"
          aria-label={t({
            key: "header.beamerToggle",
            defaultValue: "Beamer Toggle",
          })}
          onClick={() => {
            setGoogleAnalyticsEvent({
              action: "portal_dashboard_beamer_click",
            });
          }}
        >
          <NotificationIcon />
        </button>
        <div className="profile">
          <Profile
            initializeImpersonation={initializeImpersonation}
            clearImpersonation={clearImpersonation}
            initializeSwitchAccount={initializeSwitchAccount}
            clearSwitchAccount={clearSwitchAccount}
          />
        </div>
      </div>
    </header>
  );
};

export default connect((state: any) => ({
  headerState: state.application.header,
}))(Header);
